import { useEffect, useState } from 'react'
import { Employee } from '../interfaces/employee'
import { Member } from '../interfaces/member'
import { EmployeeService } from '../services/api/employee'
import { MemberService } from '../services/api/member'

const generateMemberList = (employees: Employee[]): Member[] => {
  if (!employees?.length) return []

  return employees.map((e) => ({
    firstName: e.name,
    lastName: '',
    email: '',
    employeeIndex: e.id,
    age: e.age
  }))
}

export const useMembers = (
  memberService: MemberService,
  employeeService: EmployeeService
) => {
  const [isLoadingMembers, setIsLoadingMembers] = useState(true)
  const [members, setMembers] = useState<Member[]>([])

  const handleMemberChange = (i: number, propKey: keyof Member, value: any) => {
    const newMembers = [...members]

    const currentMember: any = newMembers[i]

    currentMember[propKey] = value

    setMembers(newMembers)
  }

  useEffect(() => {
    const getEmployeeList = () => {
      employeeService.getEmployees().then(({ employees }) => {
        setMembers(generateMemberList(employees))
        setIsLoadingMembers(false)
      })
    }

    setIsLoadingMembers(true)
    memberService
      .getMembers()
      .then((members: Member[]) => {
        if (members.length > 0) {
          setMembers(members)
          setIsLoadingMembers(false)
        } else {
          getEmployeeList()
        }
      })
      .catch(getEmployeeList)
  }, [memberService, employeeService])

  return { members, handleMemberChange, isLoadingMembers }
}
